import React from 'react';
import { BrandColor } from '@styleseat/brand';

type VariousShieldIconProps = {
  width?: number;
  height?: number;
  borderColor?: BrandColor;
  backgroundColor?: any;
  children?: React.ReactNode;
} & React.SVGProps<SVGSVGElement>;

export const VariousShieldIcon = ({
  width = 24,
  height = 25,
  borderColor = BrandColor.BackInBlack,
  backgroundColor = BrandColor.Transparent,
  children,
}: VariousShieldIconProps) => (

  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 15.4429V4.37293L7.3 2.32293L12.6625 1.50293L18.4375 2.73293L20.5 4.37293V15.4429L18.4375 18.3129L12.25 22.0029L6.475 18.7229L4 15.4429Z"
      fill={backgroundColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 15.0029C3 17.6633 6 20.33 12 23.0029C18 20.3363 21 17.6696 21 15.0029C21 14.6215 21.0017 13.8062 21.0038 12.7976C21.01 9.84004 21.0197 5.22016 21 5.00293C21 4.23534 20.7054 4.05694 19.8901 3.56322C19.6432 3.41373 19.3486 3.23534 19 3.00293C17.5 2.00293 14.9952 1.00293 12 1.00293C8.56321 1.00293 5.16179 2.89507 5 3.00293C4.65139 3.23534 4.35679 3.41373 4.10993 3.56322C3.2946 4.05694 3 4.23534 3 5.00293V15.0029ZM19.0018 13.7576C19.0006 14.3867 19 14.7726 19 15.0029C19 16.5172 16.7722 18.5767 12.0009 20.8049C7.22911 18.5717 5 16.5114 5 15.0029V5.36626C5.04023 5.34128 5.08308 5.3147 5.1278 5.28695C5.45117 5.08634 5.87264 4.82487 6.1094 4.66703C7.02864 4.05421 9.83809 3.00293 12 3.00293C14.2602 3.00293 16.4143 3.68285 17.8906 4.66703C18.1274 4.82487 18.5488 5.08633 18.8722 5.28693C18.9205 5.3169 18.9666 5.34551 19.0096 5.37221C19.0117 5.96475 19.0127 7.88057 19.009 10.1127C19.0082 10.6302 19.0072 11.1724 19.0059 11.8044L19.0018 13.7576Z"
      fill={borderColor}
    />
    {children}
  </svg>
);
